import { render, staticRenderFns } from "./csiPhone.vue?vue&type=template&id=027945d2&scoped=true&"
import script from "./csiPhone.vue?vue&type=script&lang=js&"
export * from "./csiPhone.vue?vue&type=script&lang=js&"
import style0 from "./csiPhone.vue?vue&type=style&index=0&id=027945d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027945d2",
  null
  
)

export default component.exports